// extracted by mini-css-extract-plugin
module.exports = {"paper":"modal-merchant-terms-and-conditions_paper__1ErFt","dialogContent":"modal-merchant-terms-and-conditions_dialogContent__2jhjX"};